<app-page-bar></app-page-bar>

<app-page>
  <div class="template-container" *ngIf="template">
    <header class="form-header">
      <h1>{{ isNew ? 'New SMS Template' : 'Edit SMS Template' }}</h1>
      <p class="subtitle" *ngIf="!isNew">{{ template.name }}</p>
    </header>

    <form [formGroup]="form" (ngSubmit)="saveTemplate()" novalidate class="modern-form">
      <div class="field-row">
        <mat-form-field appearance="outline">
          <mat-label>Template Name</mat-label>
          <input matInput formControlName="name" placeholder="e.g., Payment Reminder" required />
          <mat-error *ngIf="form.get('name').hasError('required')">Name is required</mat-error>
        </mat-form-field>
      </div>

      <div class="field-row">
        <mat-form-field appearance="outline">
          <mat-label>Description</mat-label>
          <input matInput formControlName="description" placeholder="Internal notes about this template" />
        </mat-form-field>
      </div>

      <div class="field-row body-field">
        <mat-form-field appearance="outline">
          <mat-label>Message Text</mat-label>
          <textarea matInput formControlName="body" rows="8" placeholder="Type your SMS message here..." required></textarea>
          <mat-error *ngIf="form.get('body').hasError('required')">Message text is required</mat-error>
        </mat-form-field>
      </div>

      <div class="form-actions">
        <button mat-flat-button color="primary" type="submit" [disabled]="!form.valid">
          {{ isNew ? 'Create Template' : 'Save Changes' }}
        </button>
        <button mat-button type="button" (click)="cancel()">Cancel</button>
      </div>
    </form>

    <section class="variables-reference">
      <h2>Allowed Variables</h2>
      <ul>
        <li>client name</li>
        <li>client businessid</li>
        <li>invoice orignum</li>
        <li>invoice newnum</li>
        <li>invoice amount</li>
        <li>estimated financed amount</li>
        <li>estimated final payment amount</li>
      </ul>
    </section>
  </div>
</app-page>
